import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { CardOnFileStepNavigationProps } from './card-on-file-types';
import { CardOnFileGenericNavigation } from './navigation/card-on-file-generic-navigation';

export const CardOnFileNavigationSwitch = ({ body }: CardOnFileStepNavigationProps) => {
  return <StepNavigationSwitch generic={CardOnFileGenericNavigation} body={body} />;
};
